import ImageText from '../image-text';
import './about.scss';
import '../home/section-connector.scss';
import Values from '../values/Values';
import ContactUs from '../contact/ContactUs';
import { Helmet } from 'react-helmet-async';



const About = () => {

  // TODO In the middle of creating this component. I have done the first ImageText but not updated the CSS yet or tested anything
  return (
    <>
      <Helmet>
        <title>About Watchelm</title>
        <meta name="description" content="Learn about Watchelm, our mission, vision, and values in technical training and consultancy." />
      </Helmet>
    <div className="flow-page">

      {/* First Feature section */}
      <div className="section-container">  
        <ImageText
          title="20 Years in the Making"
          subtitle=""
          content="<p>Since 1997, our founder Nick Todd has been transforming technical training with innovative approaches that truly connect with technologists. After successfully exiting his first EdTech venture, Nick created WatchElm with a singular vision: to elevate technical education beyond conventional boundaries.</p><p>WatchElm represents the culmination of two decades dedicated to empowering technical professionals through growth-focused education. Today, Nick and our team are reimagining technical training by combining proven methodologies with cutting-edge approaches in Cloud Computing, Generative AI, and Software Architecture.</p>"
          imageSrc="/assets/images/optimized/Consultancy/image5"
          imageAlt="20 years in the making"
          imageOnRight={false}
          gradientTitle="green"
          className="twenty-years-section"
        />{/* Zigzag connector to the right */}
        <div className="section-connector zigzag-right">
          {/* Arrow head removed */}
        </div>
      </div>
      {/* Second Feature section*/}
      <div className="section-container">        <ImageText
          title="Our Mission"
          subtitle=""
          content="<p>Our mission is to <b>train the next generation of tech professionals around the world</b>, equipping organisations with bespoke training, consultancy, and EdTech solutions, <b>raising the bar in tech education</b>.</p>"
          buttonText="Learn More"
          imageSrc="/assets/images/optimized/Training/image6"
          imageAlt="Our Mission"
          buttonLink="/consulting"
          buttonLink2="/contact"
          buttonText2="Get in Touch Today"
          imageOnRight={true}
          backgroundColor="white"
          gradientTitle="red-to-green"
          className="agile-section"
          useHeaderBackground={false}
          backgroundClassName='header-style-background-consulting'
          subjectType="consultancy"
        />
        
        {/* Final connecting line with marker at bottom */}
        <div className="section-connector bottom-marker">
          {/* Using the SVG-based styling - no inner elements needed */}
        </div>
      </div>      
        
      {/* Third Training section */}
      <div className="section-container">        <ImageText
          title="Our Vision"
          subtitle=""
          content="<p>A <b>world leading</b>, trusted technical training provider, <b>redefining training and delivery standards</b> while <b>inspiring</b> and <b>educating</b> the next generation of tech professionals.</p>"
          useHeaderBackground={false}
          imageAlt="Technical Training"
          imageSrc="/assets/images/optimized/EdTech/image5"
          buttonText="Explore our Courses"
          buttonLink="/training"
          buttonText2="Get in Touch Today"
          buttonLink2="/contact"
          imageOnRight={false}
          backgroundColor="#f8f9fa"
          gradientTitle="red-to-green"
          className="training-section"
          backgroundClassName='header-style-background-training'
          subjectType="training"
        />
        {/* Zigzag connector to the left */}
        <div className="section-connector zigzag-left">
          {/* Arrow head removed */}
        </div>      </div>

      {/* Values section */}
      <Values />      <div className="section-container contact-section" >

      <div id="contact">
          <div id="contact-form-wrapper">
          <div className="contact-wrapper">
            <div className="left-panel">
              <div className="text-container">
                <div className="text-item">Rooted in Success.</div>
                <div className="text-item">Rooted in Success.</div>
                <div className="text-item focused">Rooted in Success.</div>
                <div className="text-item">Rooted in Success.</div>
                <div className="text-item">Rooted in Success.</div>
              </div>
            </div>            <div className="right-panel">
              <ContactUs />
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    </>
  );
  
}

export default About;
